import type { Campaign } from '@/models/campaign'
import type { Campaign as PopsCampaign } from '@/types/pops'
import { atom, map } from 'nanostores'

export const $campaigns = map<Record<string, Campaign>>()
export const $currentCampaignList = atom<PopsCampaign[]>([])
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'campaign/$campaigns': $campaigns,
  'campaign/$currentCampaignList': $currentCampaignList,
  // 'campaign/$promises': $promises,
}
